import "./spinner.scss";

function Spinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
      Loading
    </div>
  );
}
export default Spinner;